import React from "react";

import { calcRemainingDays } from "../../utils/GeneralUtils";

import styles from "./attentionbox.module.scss";

type Props = {
  applicantsCount?: number;
  endDate?: number;
};
export const AttentionBox: React.FC<Props> = (props) => {
  const { applicantsCount, endDate } = props;

  const remainingDay = endDate ? calcRemainingDays(endDate) : undefined;

  return (
    <div className={styles["project-details_attention-bg"]}>
      <div className={styles["project-details_attention"]}>
        <div className={styles["project-details_attention-box"]}>
          <div className={styles["project-details_attention-box_top"]}>
            応募者
          </div>
          <div
            className={styles["project-details_attention-box_bottom"]}
            test-id="test-application"
          >
            {applicantsCount !== undefined && applicantsCount > 3
              ? `${applicantsCount}`
              : "募集中"}
            {applicantsCount !== undefined && applicantsCount > 3 ? (
              <span> 人</span>
            ) : null}
          </div>
        </div>
        <div
          className={styles["project-details_attention-box"]}
          test-id="test-end-date"
        >
          {remainingDay !== undefined ? (
            remainingDay >= 0 ? (
              <>
                <div className={styles["project-details_attention-box_top"]}>
                  残り
                </div>
                <div className={styles["project-details_attention-box_bottom"]}>
                  <span>{remainingDay} 日</span>
                </div>
              </>
            ) : (
              <div className={styles["project-details_attention-box_bottom"]}>
                <span>応募期間終了</span>
              </div>
            )
          ) : (
            <div className={styles["project-details_attention-box_bottom"]}>
              <span>終了日未定</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttentionBox;
